import { RemoteForgotPasswordCognito } from 'infra/http/cognito/remote-forgot-password-cognito'
import { ForgotPasswordService } from 'infra/services/forgot-password-service'

export const makeForgotPasswordService = (): ForgotPasswordService =>
  new ForgotPasswordService(new RemoteForgotPasswordCognito())
